import { API_ROUTES } from '@/constants/apiRoutes';

export const LimitErrorMessageForApiUrl = {
  [API_ROUTES.Security.RegisterEntity]: 'register.registrationLimitExceeded',
  [API_ROUTES.Security.RetrieveRegistrationRequest]: 'register.registrationLimitExceeded'
};
